import React, { useState } from "react";
import "./faqs.css";

const faqData = {
  HOME: [
    {
      q: "What can we create?",
      a: "We provide a diverse collection of divine and stone art, including God and human statues, temples, stone decor, modern art, stone artwork, home decor, and handicrafts.",
    },
    {
      q: "Do you offer customization/personalization?",
      a: "Yes, we offer customization/personalization as per client requirements.",
    },
    {
      q: "What is the process for ordering?",
      a: "Your Dream Project In 4 Steps.",
      details: [
        { label: "Lets Connect One to One" },
        { label: "Explore Our Catalog" },
        { label: "Place Order" },
        { label: "Delivery & Installation" },
      ]
    },
    {
      q: "Do you ship in pan india?",
      a: "We offer pan india delivery, ensuring your order is properly packed and supported throughout the shipping process.",
    },
    {
      q: "Do you ship internationally?",
      a: "We offer International delivery, ensuring your order is properly packed and supported throughout the shipping process.",
    },
  ],
  "PANDEY ARTS INTERNATIONAL": [
    {
      q: "What is the procedure for an international order?",
      a: "You can connect on Phone & Whatsapp or Email with our international sales team and share your requirements. Your will get your dream project in 4 steps.",
      details: [
        { label: "Lets Connect One to One" },
        { label: "Explore Our Catalog" },
        { label: "Place Order" },
        { label: "Delivery & Installation" },
      ]
    },
    {
      q: "What is the average Customized Production & delivery time for international orders?",
      a: "The production timeline is typically 15 - 20 days, Complex design may take more time. Delivery time varies based on location and shipping method.",
    },
    {
      q: "What is your packaging procedure for international delivery?",
      a: "Your order is securely packaged in heavy-duty, foam-lined wooden crates. Our team also sends you a detailed packaging video to show you the care we take.",
    },
    {
      q: "How do you handle it if an item arrives damaged?",
      a: "Your investment is completely protected. All our international shipments are fully insured with Marine Insurance. In the unlikely event that your temple arrives damaged then dont worry, we will replace it at no extra cost to you. Just follow the steps :",
      details: [
        { label: "Contact us immediately within 7 days of unpacking." },
        { label: "Based on our damage warranty, we will offer to either repair or replace your item, depending on the damage and your insurance coverage." },
      ]
    },
    {
      q: "What will be the shipping charges?",
      a: "Shipping costs are determined by your location, package weight, and dimensions, and they vary by country. Please CONTACT US FREE for a breakdown of charges for different order sizes.",
    },
    {
      q: "Do you offer door delivery for international orders?",
      a: "Yes, we offer a Door Delivery option, which includes:",
      details: [
        { label: "Pickup from our warehouse." },
        { label: "Customs clearance at the destination country." },
        { label: "Delivery to your doorstep." },
      ]
    },
  ]
};

const Faqs = () => {
  const [activeTab, setActiveTab] = useState("HOME");
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <div className="faqs-page">
      {/* Background Banner */}
      <div className="faq-background">
        <p>Frequently Asked Question !!!</p>
      </div>

      {/* FAQ Section */}
      <div className="faq-container">
        {/* Sidebar (desktop) / Tabs (mobile) */}
        <div className="faq-sidebar">
          {/* Desktop Vertical Menu */}
          <div className="faq-menu-desktop">
            {Object.keys(faqData).map((tab) => (
              <button
                key={tab}
                className={`faq-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(tab);
                  setOpenIndex(null);
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Mobile Horizontal Tabs */}
          <div className="faq-menu-mobile">
            {Object.keys(faqData).map((tab) => (
              <button
                key={tab}
                className={`faq-tab ${activeTab === tab ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(tab);
                  setOpenIndex(null);
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {/* Accordion */}
        <div className="faq-accordion">
          {faqData[activeTab].map((item, i) => (
            <div key={i} className="faq-item">
              <button
                className="faq-question"
                onClick={() => toggleAccordion(i)}
                >
                <span>{i + 1}. {item.q}</span>
                <span className="faq-icon">{openIndex === i ? "−" : "+"}</span>
              </button>

              {openIndex === i && (
                <div className="faq-answer">
                  {item.a}
                  {item.details && (
                    <div className="faq-step-details-box">
                        {item.details.map((d, j) => (
                        <div key={j} className="faq-detail-item">
                            <span className="faq-detail-dot">●</span>
                            <div className="faq-detail-content">
                            <p className="faq-detail-label">{d.label}</p>
                            </div>
                        </div>
                        ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faqs;
